export default function hasVariablePricing(product = {}) {
  if (product.variable_pricing_amounts === undefined) return false
  if (product.variable_pricing_amounts === null) return false

  return (
    product.variable_pricing_amounts &&
    product.variable_pricing_amounts.length > 0
  )
}
